import { ethers } from "ethers";

export const TE_CONSTANTS = {
	MS_PER_SEC: 1000, // JS uses ms, Solidity returns seconds
	CONFIRMATION_BLOCKS: 200,
	DEFAULT_DECIMALS: 2,
	PCT_ONE_HUNDRED: ethers.BigNumber.from(10).pow(18),
	SEC_PER_WEEK: 604_800, // JS uses ms, Solidity returns seconds
	MS_PER_YEAR: 31_536_000_000,
	WITHDRAW_NOW_SLIPPAGE: "0.01",
	ZeroXExchangeProxy: "0xDef1C0ded9bec7F1a1670819833240f027b25EfF", // Unconfirmed on chains other than Avalanche C-Chain
	ZeroXAPIKeyHeader: { "0x-api-key": "f0ce23d4-b6b7-471a-8373-365ce32c9181" }, // Free API key
	// AvvyDomains: "0x1ea4e7A798557001b99D88D6b4ba7F7fc79406A9", // only on the Avalanche C-Chain

	// https://www.rapidtables.com/convert/number/hex-to-decimal.html
	AppChainId_AVAX_Mainnet: 0xA86A,
	AppChainId_AVAX_Fuji: 0xA869,
	AppChainId_Hardhat_Fork: 0x7A69
};

export const AVAX_MAIN_NET = 43114;
export const AVAX_FUJI_NET = 43113;

// export const MIN_APP_BLOCKCHAIN_UPDATE_RATE_MS = 3000;
export const MAX_APP_BLOCKCHAIN_UPDATE_RATE_MS = 1000;

export const projectId = "749490e479550e5fa36c8fa2d3ad3e1b";

type NetworkProfile = {
	explorer: string;
	label: string;
	nativeCurrency: {
		name: string;
		symbol: string;
		decimals: 18;
	};
	rpcUrl: string;
};

export const CHAIN_INFO: { [key: number]: NetworkProfile; } = {
	[AVAX_MAIN_NET]: {
		explorer: "https://snowtrace.io/",
		label: "Avalanche (C-Chain)",
		nativeCurrency: { name: "AVAX", symbol: "AVAX", decimals: 18 },
		rpcUrl: "https://api.avax.network/ext/bc/C/rpc",
	},
	[AVAX_FUJI_NET]: {
		explorer: "https://testnet.snowtrace.io/",
		label: "Avalanche (C-Chain) (TEST)",
		nativeCurrency: { name: "AVAX", symbol: "AVAX", decimals: 18 },
		rpcUrl: "https://api.avax-test.network/ext/bc/C/rpc",
	}
};

// Public URL
// export const SUPABASE_PROJECT_URL = "https://slfawdnjhuwzdqkuvlig.supabase.co"; // DEV
export const SUPABASE_PROJECT_URL = "https://ybdsdjcrwtspzuxuvahf.supabase.co"; // PROD
// Public API key
// export const SUPABASE_PROJECT_API_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNsZmF3ZG5qaHV3emRxa3V2bGlnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTA0MzI4MzYsImV4cCI6MjAyNjAwODgzNn0.aURHozK0gHmQpR7eKI431285RP_D_W32oWICeLqh3qw"; // DEV
export const SUPABASE_PROJECT_API_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InliZHNkamNyd3RzcHp1eHV2YWhmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTA0MjczNDQsImV4cCI6MjAyNjAwMzM0NH0.BhoCTLQVWFVntT314SJFkXrQS4nz1vt2gVpeGPQmRPw"; // PROD
